var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{model:{value:(_vm.iva_aplicado),callback:function ($$v) {_vm.iva_aplicado=$$v},expression:"iva_aplicado"}},[_vm._v(" Precios con IVA ")])
}
var staticRenderFns = []

export { render, staticRenderFns }